import React from 'react';
import { Animated } from 'react-native';
import { TypographyVariant } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import RowCenter from '../../layout/RowCenter';
import Typography from '../../typography/Typography';
import useIsOnline from '../hooks/useIsOnline';
import useNetworkAnimations from './useNetworkAnimations';
const NetworkStatusIndicator = () => {
    const [{ theme, styles }] = useTheme(stylesGenerator);
    const isOnline = useIsOnline();
    const { isVisible, containerAnimatedStyle, textAnimatedStyle } = useNetworkAnimations();
    // Don't render if not visible
    if (!isVisible) {
        return null;
    }
    return (React.createElement(Animated.View, { style: [
            styles.container,
            containerAnimatedStyle
        ] },
        React.createElement(RowCenter, { style: styles.content },
            React.createElement(Animated.View, { style: textAnimatedStyle },
                React.createElement(Typography, { variant: TypographyVariant.BODY, align: 'center', style: { color: isOnline ? theme.palette.positive.contrast : theme.palette.negative.contrast } }, isOnline
                    ? "You're back online"
                    : "You're offline, some features will not be available")))));
};
const stylesGenerator = createThemedStyle(({ theme }) => ({
    container: {
        paddingHorizontal: theme.spacing.standard.md,
        overflow: 'hidden',
    },
    content: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
}));
export default NetworkStatusIndicator;
